import React from 'react'
import { FilterForm } from '../../../components'
import { SystemProvider } from '../../../features/system/provider'

const Sidebar = ({query}) => {
  return (
    <div className="lg:pr-12">
      <SystemProvider>
        <FilterForm query={query} id="sidebar-filter-form" options={{
          keyword: true,
          location: true,
          type: true,
          date: true,
          category: true
        }}/>
      </SystemProvider>
    </div>
  )
}

export { Sidebar }
